// @flow
import React, { Component } from "react";
import InfiniteCalendar from "react-infinite-calendar";

import { InfiniteCalendarBase } from "imagus-components";
import "react-infinite-calendar/styles.css";

class InfiniteCalendarSelect extends Component<*> {
  render(): * {
    return (
      <InfiniteCalendarBase calendarLib={InfiniteCalendar} {...this.props} />
    );
  }
}

export default InfiniteCalendarSelect;
